<!--首页-->
<template>
	<div class="wifiContent">
		<div class="pageModal" v-show="isShowCon">
			<div class="title" v-show="titleOne">
				提示
				<img src="/static/images/forfree/close.png" @click="closeModal" />
			</div>
			<div class="title2" v-show="titleTwo">
				<span>恭喜您领取成功</span>
				<img src="/static/images/wifi/close.png" @click="closeModal" />
			</div>
			<div class="page-cont" v-show="iscontOne">
				<div class="t2">请输入正确的手机号！</div>
			</div>
			<div class="page-cont" v-show="iscontTwo">
				<div class="t2" v-html="cont"></div>
				<div class="tips mtp" v-show="titleTwo">免费试玩账号领取有效期至</div>
				<div class="tips" v-show="titleTwo">{{ endTime }}</div>
				<div class="liqu-button-small" @click="onDownLoad" v-show="downLoad">立即下载</div>
			</div>
		</div>
		<div class="wifi-top">
			<div class="wifi-login">
				<div class="title lqsm">领取免费试玩资格</div>
				<div class="input">
					<input
						type="text"
						placeholder="请输入手机号"
						v-model="moblie"
						oninput="if(value.length>11)value=value.slice(0,11)"
					/>
				</div>
				<div class="code-input">
					<input
						type="text"
						placeholder="请输入验证码"
						v-model="phoneCode"
						oninput="if(value.length>6)value=value.slice(0,6)"
					/>
					<span class="yzmbtn" @click="onClick" v-show="!isSend">获取验证码</span>
					<span class="yzmbtn" v-show="isSend">{{ codeTime }}s</span>
				</div>
				<div class="liqu-button" @click="onButtonClick">立即领取</div>
			</div>
		</div>

		<div class="wifi-bottom">
			<div class="tips-title lqsm">领取说明</div>
			<div class="wifi-step">
				<div class="tit">
					<span class="t1">第一步</span>
					<span class="t2">下载app</span>
					<a class="downbtn" href="http://download.xubei.com/?f=androidApp">立即下载</a>
				</div>
				<p class="txt">
					<i>1</i>
					应用市场下载“虚贝”APP，或复制下方下载链接在浏览器中 打开下载“虚贝APP”；
					<a
						class="downbtn copy_btn"
						href="javascript:"
						:data-clipboard-text="'http://download.xubei.com/?f=androidApp'"
					>
						复制链接
					</a>
				</p>
				<p class="txt"><span>http://download.xubei.com/?f=androidApp</span></p>
			</div>

			<div class="wifi-step">
				<div class="tit">
					<span class="t1">第二步</span>
					<span class="t2">免费兑换账号</span>
				</div>
				<div class="tips">温馨提示：兑换时间为试玩开始时间</div>
				<p class="txt">
					<i>1</i>
					用领取免费试玩资格的手机号登录虚贝App；
				</p>
				<p class="txt">
					<i>2</i>
					点击“我的”-“兑换中心”进入兑换页面；
				</p>
				<p class="txt">
					<i>3</i>
					选择游戏，领取试玩账号
				</p>
				<p class="txt copyright">*本活动最终解释权归虚贝所有</p>
			</div>
		</div>
		<div class="mask" v-show="isMask"></div>
	</div>
</template>

<script>
import { Toast } from 'mint-ui';
import Clipboard from 'clipboard';
import { PROXY_URL } from '../../../config/env';
let telReg = /^1\d{10}$/;

export default {
	name: 'wifiys',
	components: {},
	data: function () {
		return {
			channel: this.$route.query.channel || '',
			moblie: '',
			cont: '',
			phoneCode: '',
			isChecked: false,
			downLoad: false,
			titleOne: true,
			titleTwo: false,
			isShowCon: false,
			iscontOne: false,
			iscontTwo: false,
			iscontThree: false,
			isMask: false,
			isSend: false,
			codeTime: 60,
			endTime: ''
		};
	},
	mounted() {
		let clipboard = new Clipboard('.copy_btn');
		clipboard.on('success', function (e) {
			Toast('复制成功');
		});
		clipboard.on('error', function (e) {
			Toast('复制失败，请手动复制');
		});
	},
	methods: {
		onClick: function () {
			let self = this;
			if (!telReg.test(self.moblie)) {
				this.isShowCon = true;
				this.isMask = true;
				this.iscontOne = true;
				return false;
			}
			this.ajax
				.get(PROXY_URL.service + '/anon/diversion/vfMobileAndType?mobile=' + self.moblie + '&type=2')
				.then(res => {
					console.log(res);
					if (!res.data.success) {
						self.getZuli();
					} else {
						this.cont =
							this.moblie.substr(0, 3) +
							'****' +
							this.moblie.substr(7) +
							'已经领取过，直接打开“虚贝”APP登录即可,如未安装请先安装APP！';
						this.downLoad = true;
						this.isShowCon = true;
						this.isMask = true;
						this.iscontOne = false;
						this.iscontTwo = true;
					}
				});
			// if(this.isChecked){
			//   this.isShowCon = true
			//   this.iscontOne = false
			//   this.iscontTwo = true
			// }else{
			//   this.isShowCon = true
			//   this.iscontOne = false
			//   this.iscontTwo = false
			//   this.iscontThree = true
			// }
		},
		onButtonClick: function () {
			let self = this;
			if (!telReg.test(self.moblie)) {
				this.isShowCon = true;
				this.isMask = true;
				this.iscontOne = true;
				return false;
			}
			if (this.phoneCode == '') {
				this.cont = '验证码不能为空!';
				this.isShowCon = true;
				this.isMask = true;
				this.iscontOne = false;
				this.iscontTwo = true;
				return false;
			}
			this.ajax
				.get(
					PROXY_URL.service + '/anon/diversion/receive?mobile=' + self.moblie + '&userSource=2&code=' + self.phoneCode
				)
				.then(res => {
					console.log(res);
					if (res.data.success) {
						this.cont =
							this.moblie.substr(0, 3) + '****' + this.moblie.substr(7) + '获得了免费试玩资格,下载虚贝APP免费玩';
						this.titleOne = false;
						this.titleTwo = true;
						this.isShowCon = true;
						this.isMask = true;
						this.iscontOne = false;
						this.iscontTwo = true;
						this.downLoad = true;
						this.endTime = res.data.result.result;
					} else {
						this.cont = res.data.message;
						this.isShowCon = true;
						this.isMask = true;
						this.iscontOne = false;
						this.iscontTwo = true;
					}
				});
		},
		getZuli: function () {
			console.log(this);
			var self = this;
			this.ajax.get(PROXY_URL.user + '/reg/captcha/getUrl').then(res => {
				if (res.data.code == '1') {
					var HEAD = document.getElementsByTagName('head').item(0) || document.documentElement;
					var script = document.createElement('script');
					script.setAttribute('type', 'text/javascript');
					script.setAttribute('src', res.data.result);
					HEAD.appendChild(script);

					script.onload = function () {
						var capOption = { callback: cbfn, type: 'popup' };
						capInit(document.getElementById('TCaptcha'), capOption);
						//回调函数：验证码页面关闭时回调
						self.isMask = true;
						function cbfn(retJson) {
							if (retJson.ret == 0) {
								// 用户验证成功
								console.log(retJson);
								self.isMask = false;

								let data = {
									ticket: retJson.ticket
								};

								self.ajax
									.get(
										PROXY_URL.service +
											'/anon/diversion/sendCode?mobile=' +
											self.moblie +
											'&businessNo=xubei&ticket=' +
											data.ticket
									)
									.then(res => {
										console.log(res);
										if (res.data.code == '1') {
											this.cont = '验证码发送成功!';
											this.isShowCon = true;
											this.isMask = true;
											this.iscontOne = false;
											this.iscontTwo = true;
											self.isSend = true;
											self.countTime();
										} else {
											Toast(res.data.message);
										}
									})
									.catch(error => {});

								capDestroy();
							} else {
								//用户关闭验证码页面，没有验证
								self.isMask = false;
								capDestroy();
							}
						}
					};
				} else {
					Toast(res.data.message);
				}
			});
		},
		onDownLoad: function () {
			window.location.href = 'http://download.xubei.com/?f=androidApp';
		},
		countTime() {
			let time = 60;
			let self = this;
			let codeT = window.setInterval(function () {
				time--;
				self.codeTime = time;
				if (time == 0) {
					self.isSend = false;
					self.codeTime = 60;
					window.clearInterval(codeT);
				}
			}, 2000);
		},
		closeModal: function () {
			this.titleOne = true;
			this.titleTwo = false;
			this.isShowCon = false;
			this.isMask = false;
			this.iscontOne = false;
			this.iscontTwo = false;
			this.downLoad = false;
		}
	}
};
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
input::-webkit-input-placeholder {
	/* placeholder颜色  */
	color: #999;
}

.wifiContent {
	width: 100%;
	height: 100%;
	background: #412ce1;
	.lqsm {
		color: #fff;
		text-align: center;
		font-size: px2rem(36rem);
		position: relative;
	}
	.lqsm:after {
		content: '';
		width: px2rem(80rem);
		height: px2rem(9rem);
		background: #8287fc;
		box-shadow: 0 2px 2px 0 #342ec9;
		position: absolute;
		left: 45%;
		bottom: px2rem(-15rem);
	}

	.liqu-button-small {
		background: url(/static/images/forfree/download.png) no-repeat;
		background-size: 100% 100%;
		width: px2rem(264rem);
		height: px2rem(80rem);
		line-height: px2rem(70rem);
		margin: 0 auto;
		font-size: px2rem(32rem);
		color: #ffffff;
		margin-top: px2rem(25rem);
	}
	.wifi-top {
		width: px2rem(750rem);
		height: px2rem(767rem);
		background: url(/static/images/wifi/ys_bg1.png) no-repeat;
		background-size: 100% 100%;

		.game-list {
			overflow: hidden;
			padding-top: px2rem(290rem);
			display: -webkit-box;
			overflow-x: scroll;
			-webkit-overflow-scrolling: touch;
			margin-right: px2rem(20rem);
			li {
				// width: px2rem(296rem);
				width: px2rem(360rem);
				background: #fff;
				border-radius: 8px;
				overflow: hidden;
				margin-left: px2rem(20rem);
				text-align: center;
				.img {
					width: px2rem(265rem);
					height: px2rem(266rem);
					margin: px2rem(15rem) auto;
					padding-top: px2rem(215rem);
					color: #fff;
					font-size: px2rem(32rem);
				}
				.cont {
					background: #ecf2f7;
					padding: px2rem(10rem) 0;
					span {
						display: block;
						font-size: px2rem(24rem);
						color: #19094f;
					}
				}
				.tu1 {
					background: url(/static/images/wifi/tu1.png) no-repeat;
					background-size: cover;
				}
				.tu2 {
					background: url(/static/images/wifi/tu2.png) no-repeat;
					background-size: cover;
				}
				.tu3 {
					background: url(/static/images/wifi/tu3.png) no-repeat;
					background-size: cover;
				}
				.tu4 {
					background: url(/static/images/wifi/tu4.png) no-repeat;
					background-size: cover;
				}

				.tu5 {
					background: url(/static/images/wifi/tu5.png) no-repeat;
					background-size: cover;
				}
			}
		}
		.wifi-login {
			width: 100%;
			height: px2rem(564rem);
			text-align: center;
			.title {
				font-size: px2rem(36rem);
				color: #ffffff;
				padding-top: px2rem(242rem);
			}
			.input {
				margin-top: px2rem(50rem);
				margin-bottom: px2rem(20rem);
				input {
					width: px2rem(612rem);
					height: px2rem(85rem);
					line-height: px2rem(85rem);
					border-radius: 10px;
					padding-left: px2rem(15rem);
					font-size: px2rem(32rem);
				}
			}
			.code-input {
				input {
					width: px2rem(366rem);
					height: px2rem(86rem);
					line-height: px2rem(86rem);
					border-radius: 10px;
					margin-right: px2rem(34rem);
					padding-left: px2rem(15rem);
					font-size: px2rem(32rem);
				}
				.yzmbtn {
					display: inline-block;
					background: url(/static/images/wifi/getCode.png) no-repeat;
					background-size: cover;
					width: px2rem(214rem);
					height: px2rem(86rem);
					line-height: px2rem(86rem);
					color: #fff;
					font-size: px2rem(32rem);
					vertical-align: middle;
				}
			}
			.liqu-button {
				background: url(/static/images/wifi/linqu.png) no-repeat;
				width: px2rem(445rem);
				height: px2rem(102rem);
				line-height: px2rem(102rem);
				background-size: cover;
				margin: 0 auto;
				font-size: px2rem(36rem);
				color: #ffffff;
				margin-top: px2rem(39rem);
			}
		}
	}
	.wifi-bottom {
		width: px2rem(750rem);
		height: px2rem(797rem);
		background: url(/static/images/wifi/ys_bg2.png) no-repeat;
		background-size: 100% 100%;
		padding: 0 px2rem(50rem) px2rem(20rem) px2rem(50rem);
		.tips-title {
			color: #fff;
			font-size: px2rem(36rem);
			text-align: center;
			margin-bottom: px2rem(90rem);
			top: px2rem(-10rem);
		}
		.wifi-step {
			margin-bottom: px2rem(32rem);
			.tips {
				font-size: px2rem(24rem);
				color: #ffffff;
				margin-bottom: px2rem(23rem);
			}
			.downbtn {
				display: inline-block;
				background: #be3dff;
				box-shadow: 0 2px 4px 0 #3145c4;
				border-radius: 15px;
				color: #fff;
				width: px2rem(140rem);
				height: px2rem(48rem);
				line-height: px2rem(48rem);
				text-align: center;
			}
			.tit {
				display: flex;
				display: -webkit-flex;
				height: px2rem(52rem);
				line-height: px2rem(52rem);
				margin-bottom: px2rem(20rem);
				.t1 {
					background: url(/static/images/wifi/tips.png) no-repeat;
					width: px2rem(148rem);
					height: px2rem(52rem);
					line-height: px2rem(52rem);
					background-size: cover;
					text-align: center;
					color: #fff;
					font-size: px2rem(28rem);
				}
				.t2 {
					color: #fff;
					font-size: px2rem(28rem);
					padding: 0 px2rem(20rem);
				}
			}
			.txt {
				color: #ebe4ff;
				word-wrap: break-word;
				font-size: px2rem(24rem);
				line-height: px2rem(44rem);
				margin-bottom: px2rem(5rem);
				i {
					color: #ebe4ff;
					border: 1px solid #fff;
					border-radius: 50%;
					display: inline-block;
					width: px2rem(29rem);
					line-height: px2rem(27rem);
					text-align: center;
					font-size: px2rem(22rem);
					margin-right: px2rem(10rem);
				}
				span {
					color: #ebe4ff;
					padding-right: px2rem(20rem);
				}
			}
		}
		.copyright {
			color: #fff;
			opacity: 0.5;
			margin-top: px2rem(30rem);
		}
	}
}
.pageModal {
	width: px2rem(560rem);
	position: absolute;
	left: 50%;
	top: 40%;
	z-index: 10;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	text-align: center;
	.title {
		width: 100%;
		height: px2rem(76rem);
		line-height: px2rem(76rem);
		background: url(/static/images/forfree/title1.png) no-repeat;
		background-size: cover;
		font-size: px2rem(34rem);
		color: #fff;
		position: relative;
		img {
			width: px2rem(24rem);
			height: px2rem(24rem);
			position: absolute;
			right: px2rem(20rem);
			top: 50%;
			-webkit-transform: translate(0, -50%);
			-moz-transform: translate(0, -50%);
			transform: translate(0, -50%);
			padding: px2rem(10rem);
		}
	}
	.title2 {
		width: 100%;
		height: px2rem(312rem);
		background: url(/static/images/wifi/sc_bg.png) no-repeat;
		background-size: cover;
		font-size: px2rem(34rem);
		color: #fff;
		position: relative;
		span {
			color: #fff;
			display: block;
			padding-top: px2rem(50rem);
		}
		img {
			width: px2rem(56rem);
			height: px2rem(92rem);
			position: absolute;
			right: 0;
			top: px2rem(-45rem);
			-webkit-transform: translate(0, -50%);
			-moz-transform: translate(0, -50%);
			transform: translate(0, -50%);
			padding: px2rem(10rem);
		}
	}
	.page-cont {
		background: #fff;
		width: 100%;
		padding: px2rem(35rem) px2rem(32rem) px2rem(48rem) px2rem(32rem);
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
		.t1 {
			color: #333;
			font-size: px2rem(34rem);
			span {
				padding: 0 px2rem(20rem);
				vertical-align: middle;
			}
			img {
				width: px2rem(41rem);
				height: px2rem(41rem);
				vertical-align: middle;
			}
			img:first-child {
				transform: rotate(-90deg);
			}
		}
		.t2 {
			color: #333;
			font-size: px2rem(30rem);
		}

		.tips {
			font-size: px2rem(24rem);
			color: #999;
		}
		.mtp {
			margin-top: px2rem(20rem);
		}
	}
}
.mask {
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	background: #000;
	opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/wifi/wifiyx.vue